import { render } from "./CookieComplyButton.vue?vue&type=template&id=27abc18f"
import script from "./CookieComplyButton.vue?vue&type=script&lang=js"
export * from "./CookieComplyButton.vue?vue&type=script&lang=js"

import "./CookieComplyButton.vue?vue&type=style&index=0&id=27abc18f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__